import { render, staticRenderFns } from "./crossArea.vue?vue&type=template&id=41203d94&scoped=true&"
import script from "./crossArea.vue?vue&type=script&lang=js&"
export * from "./crossArea.vue?vue&type=script&lang=js&"
import style0 from "./crossArea.vue?vue&type=style&index=0&id=41203d94&scoped=true&lang=css&"
import style1 from "./crossArea.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41203d94",
  null
  
)

export default component.exports